<template>
  <SearchContainer @search="search">
    <template slot="default">
      <span class="required-fields">
        {{ $t("pages.details.requiredFields") }}
      </span>
      <div class="row">
        <div class="col-12 col-sm-4 d-flex">
          <card divider>
            <div class="d-flex">
              <div class="d-flex flex-column pr-2">
                <HorizontalDetailTitle
                  :label="$t('sections.logs.search.start')"
                />
                <HorizontalDetailTitle
                  :label="$t('sections.logs.search.end')"
                  :valid="validEndTime"
                />
              </div>
              <div class="d-flex flex-column flex-fill">
                <HorizontalDetailInput
                  type="datetime"
                  :field="query.startDate"
                  :valid="validStartTime"
                  :edit="true"
                  :errorLabel="
                    $t('components.horizontalInput.invalidStartDate')
                  "
                  @input="(e) => onInput('startDate', e)"
                />
                <HorizontalDetailInput
                  type="datetime"
                  :field="query.endDate"
                  :valid="validEndTime"
                  :edit="true"
                  :errorLabel="$t('components.horizontalInput.invalidEndDate2')"
                  @input="(e) => onInput('endDate', e)"
                />
              </div>
            </div>
            <span class="required-fields">
                {{ $t("sections.logs.search.intervals") }}
              </span>
          </card>
        </div>
        <div class="col-sm-4">
          <div class="d-flex flex-column">
            <div class="row mb-2">
              <div class="col-12">
                <Input
                  type="dropdown"
                  :label="$t('sections.logs.search.direction')"
                  :items="$t('directions')"
                  :field="query.direction"
                  @input="(e) => onInput('direction', e)"
                />
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-12">
                <Input
                  type="dropdown"
                  :label="$t('sections.logs.search.module')"
                  :items="$t('modulesOCPI')"
                  :field="query.module"
                  @input="(e) => onInput('module', e)"
                />
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-12">
                <Input
                  type="dropdown"
                  :label="$t('sections.logs.search.method')"
                  :items="$t('sections.logs.search.methodOptions')"
                  :field="query.method"
                  @input="(e) => onInput('method', e)"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="d-flex flex-column">
            <div class="row mb-2">
              <div class="col-12">
                <Input
                  type="text"
                  :label="$t('sections.logs.search.partyId')"
                  :field="query.partyId"
                  @input="(e) => onInput('partyId', e)"
                />
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-12">
                <Input
                  type="dropdown"
                  :label="$t('sections.logs.search.status')"
                  :items="$t('sections.logs.search.statusOptions')"
                  :field="query.status"
                  @input="(e) => onInput('status', e)"
                />
              </div>
            </div>
            <div class="d-flex flex-column align-items-end">
              <div class="row mb-2">
                <div class="col-12">
                  <el-button
                    type="primary"
                    @click="search"
                    v-bind:disabled="!validFields"
                    class="mb-3"
                  >
                    <font-awesome-icon
                      icon="fa-regular fa-magnifying-glass"
                      class="mr-2"
                    />
                    {{ $t("sections.common.search.searchButton") }}
                  </el-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </SearchContainer>
</template>

<script>
import SearchContainer from '@/components/sections/common/SearchContainer.vue';
import HorizontalDetailTitle from '@/components/ui/HorizontalDetailTitle.vue';
import HorizontalDetailInput from '@/components/ui/HorizontalDetailInput.vue';
import Input from '@/components/ui/Input.vue';

export default {
  name: 'LogsOCPISearchOptions',
  components: {
    SearchContainer,
    Input,
    HorizontalDetailTitle,
    HorizontalDetailInput,
  },

  data() {
    return {
      query: {
        timestamp: '',
        module: '',
        direction: '',
        startDate: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000),
        endDate: new Date(),
        partyId: '',
        method: '',
        status: '',
      },
    };
  },
  computed: {
    validSearch() {
      // TODO check required fields
      return true;
    },
    validEndTime() {
      if (this.query.endDate) return true;
      return false;
    },
    validStartTime() {
      if (this.query.startDate && this.query.endDate >= this.query.startDate) return true;

      return false;
    },

    validFields() {
      return (
        this.validEndTime
        && this.validStartTime
        && this.query.startDate
        && this.query.endDate
      );
    },
  },
  methods: {
    onInput(field, value) {
      if (
        field === 'startDate'
        && value !== null
        && this.query.endDate
          >= new Date(value.getTime() + 7 * 24 * 60 * 60 * 1000)
      ) {
        this.query.endDate = new Date(
          value.getTime() + 7 * 24 * 60 * 60 * 1000,
        );
      }
      if (field === 'endDate' && value !== null) {
        this.query.startDate = new Date(
          value.getTime() - 7 * 24 * 60 * 60 * 1000,
        );
      }
      this.query[field] = value;
    },
    search() {
      this.$emit('onSearch', this.query);
    },
    resetFilters() {
      this.query = {
        timestamp: '',
        module: '',
        direction: '',
        startDate: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000),
        endDate: new Date(),
        partyId: '',
        method: '',
        status: '',
      };

      this.$emit('onSearch', this.query);
    },
  },
};
</script>
<style lang="scss" scoped>
.options-container {
  --input-label-width: 90px;
}
</style>
